(function(){
    'use strict';

    angular.module('elogbooks.helpdesk', [
        'elogbooks.helpdesk.dashboard',
        'elogbooks.helpdesk.sites',
        'elogbooks.helpdesk.satisfactionsurveys'
    ]);
})();
